import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  currentYear? : number;
  companyName : string = "Property Handling";
  ngOnInit() {
    this.setCurrentYear();
  }
  setCurrentYear = () => {
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();    
  }
}
